// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__13RBP","modalForm":"UpgradeEpcsModal_modalForm__swLWI","modalFooter":"UpgradeEpcsModal_modalFooter__3C5_x"};